import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Spinner = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        zIndex: 9999,
      }}
    >
      <CircularProgress
        sx={{
          animation: "colorChange 2s infinite alternate",
          "@keyframes colorChange": {
            "0%": { color: "#5BB8C4" },
            "100%": { color: "#E0A92B" },
          },
        }}
        size={80}
        thickness={5}
      />
    </Box>
  );
};

export default Spinner;
